import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import StepProgress from "./steprogress";
import {
  dutyType,
  UpdateOneTimeServices,
} from "../../../../Service/partnerAPI";
import { getLookupData } from "../../../../Service/lookup";
import secureLocalStorage from "react-secure-storage";
import { showToast } from "../../../../reusableUI/toaster";
import { MdExpandLess, MdExpandMore } from "react-icons/md";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DesktopTimePicker } from "@mui/x-date-pickers/DesktopTimePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import TextField from "@mui/material/TextField";
import dayjs from "dayjs";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);

const RateFix = () => {
  const navigate = useNavigate();
  const [toastMsg, setToastMsg] = useState(null);
  const [activeTab, setActiveTab] = useState("onetime");
  const [showPersonalCare, setShowPersonalCare] = useState(true);
  const [regularServices, setRegularServices] = useState([]);
  const [isChecked, setIsChecked] = useState(false);
  const [amount, setAmount] = useState("");
  const [startTime247, setStartTime247] = useState("");
  const [lookup, setLookUp] = useState([]);
  const [personalChecked, setPersonalChecked] = useState({});
  const [personalAmount, setPersonalAmount] = useState({});
  const [checkedStates, setCheckedStates] = useState({});
  const [amountStates, setAmountStates] = useState({});
  const [otherServices, setOtherServices] = useState("");
  const [fromTime, setFromTime] = useState();
  const [toTime, setToTime] = useState();
  const formattedFromTime = dayjs(fromTime)
    .utc()
    .format("YYYY-MM-DDTHH:mm:ss.SSS[+00:00]");
  const formattedToTime = dayjs(toTime)
    .utc()
    .format("YYYY-MM-DDTHH:mm:ss.SSS[+00:00]");
  // console.log("From:", formattedFromTime);
  // console.log("To:", formattedToTime);
  const theme = createTheme({
    components: {
      MuiOutlinedInput: {
        styleOverrides: {
          root: {
            minHeight: 32,
            fontSize: "0.75rem",
            "& .MuiOutlinedInput-input": {
              padding: "6px 8px",
              height: 18,
              boxSizing: "content-box",
            },
          },
        },
      },
      MuiInputAdornment: {
        styleOverrides: {
          root: {
            "& svg": {
              fontSize: 18,
            },
          },
        },
      },
    },
  });

  const [checkedRates, setCheckedRates] = useState({
    "24/7": false,
    morning9: false,
    morning12: false,
    night12: false,
  });

  const [rates, setRates] = useState({
    "24/7": "",
    morning9: "",
    morning12: "",
    night12: "",
  });

  const [timeSlots, setTimeSlots] = useState({
    "24/7": [],
    morning9: [],
    morning12: [],
    night12: [],
  });

  const checkCondition = Object.values(checkedRates).some(
    (item) => item === true
  );
  const rateCondition = Object.values(rates).some((item) => item.length > 0);

  const isAnyTimeSlotFilled = Object.values(timeSlots).some(
    (arr) => arr.length > 0
  );
  const isNext = startTime247.length > 0 && rates["24/7"]?.length > 0;

  const isNextAllowed =
    (checkCondition && rateCondition && isAnyTimeSlotFilled) || isNext;
  console.log(isNext);

  const personalCareItems = [
    "Vital Signs",
    "Personal Care",
    "Medication Management",
    "Back Care",
    "Output",
    "Transfer",
    "Nutrition",
    "Injection",
  ];

  useEffect(() => {
    getLookup();
  }, []);

  useEffect(() => {
    const updatedAmounts = {};
    personalCareItems.forEach((item) => {
      updatedAmounts[item] = amount;
    });
    setPersonalAmount(updatedAmounts);
  }, [amount]);

  const getLookup = async () => {
    const res = await getLookupData();
    if (res.error === false) {
      setLookUp(res.data);
    }
  };

  const morning9hrs = lookup
    .filter((item) => item.type === "morningShift9Data")
    .map((item) => item.label);

  const morning12hrs = lookup
    .filter((item) => item.type === "morningSHift12Data")
    .map((item) => item.label);

  const night12hrs = lookup
    .filter((item) => item.type === "nightShift12Data")
    .map((item) => item.label);

  const timeSlotOptions = {
    morning9: morning9hrs,
    morning12: morning12hrs,
    night12: night12hrs,
  };

  const serviceCategories = [
    {
      title: "Iv Fluid",
      key: "IV Fluid",
    },
    {
      title: "Suppository",
      key: "Suppository",
    },
    {
      title: "Catheter Care",
      key: "Catheter Care",
    },
    {
      title: "Wound Care",
      key: "Wound Care",
    },
    {
      title: "Back Care",
      key: "back care",
    },
    {
      title: "Nutrition",
      key: "nutrition",
    },
    {
      title: "Tracheostomy",
      key: "Tracheostomy",
    },
    {
      title: "Continuous Ryle's Tube Aspiration",
      key: "Continuous Ryle's Tube Aspiration",
    },
    {
      title: "Hourly Ryle's Tube Aspiration",
      key: "Hourly Ryle's Tube Aspiration",
    },
  ];

  const handleCheckboxChange = (key) => {
    setCheckedRates((prev) => {
      const updated = { ...prev, [key]: !prev[key] };

      // Handle 24/7 special case
      if (key === "24/7") {
        if (!prev[key]) {
          // was false, now checked
          setStartTime247("12AM");
        } else {
          // now unchecked
          setStartTime247("");
        }
      }

      return updated;
    });
  };

  const handleRateChange = (key, value) => {
    setRates((prev) => ({ ...prev, [key]: value || "" }));
  };

  const handleTimeSlotToggle = (key, slot) => {
    setTimeSlots((prev) => {
      const selected = new Set(prev[key]);
      selected.has(slot) ? selected.delete(slot) : selected.add(slot);
      return { ...prev, [key]: [...selected] };
    });
  };

  const handleNext = async () => {
    const rateMap = {
      "24/7": { shift: "24/7", type: "24/7" },
      morning9: { shift: "morning", type: "9H" },
      morning12: { shift: "morning", type: "12H" },
      night12: { shift: "night", type: "12H" },
    };

    const dutyTypes = Object.entries(rates)
      .filter(([key]) => checkedRates[key])
      .map(([key, fee]) => {
        const config = rateMap[key];
        if (!config) return null;

        return {
          shift: config.shift,
          type: config.type,
          fee: fee,
          slots: key === "24/7" ? [startTime247] : timeSlots[key] || [],
        };
      })
      .filter(Boolean);

    setRegularServices(dutyTypes);

    if (dutyTypes.length === 0) {
      showToast("Please select at least one duty type.", "Error");
      return;
    }

    const hasEmptyFee = dutyTypes.some(
      (item) => item.fee === "" || item.fee === null || item.fee === undefined
    );
    if (hasEmptyFee) {
      showToast("Please enter a fee for all selected duty types.", "Error");
      return;
    }

    const hasEmptySlots = dutyTypes.some(
      (item) => !Array.isArray(item.slots) || item.slots.length === 0
    );
    if (hasEmptySlots) {
      showToast(
        "Please select at least one time slot for all selected duty types.",
        "Error"
      );
      return;
    }

    console.log(dutyTypes);

    try {
      const res = await dutyType(dutyTypes);

      if (res?.error === false) {
        setActiveTab("onetime");
      } else {
        showToast(
          res?.msg || "Failed to submit duty types. Please try again.",
          "Error"
        );
      }
    } catch (error) {
      console.error("Error submitting duty types:", error);
      showToast(
        "Something went wrong while submitting. Please try again.",
        "Error"
      );
    }
  };

  const handleSubmit = async () => {
    if (!fromTime) {
      showToast("Please Enter the From Time slot", "Error");
      return;
    }
    if (!toTime) {
      showToast("Please Enter the To Time slot", "Error");
      return;
    }

    const invalidServiceCost = Object.entries(amountStates).some(
      ([key, value]) => value !== "" && (isNaN(value) || Number(value) <= 0)
    );
    if (invalidServiceCost) {
      showToast("Enter valid costs for all additional services", "Error");
      return;
    }

    const hasAnyValidService =
      amount ||
      Object.values(amountStates).some((val) => val && Number(val) > 0);

    if (!hasAnyValidService) {
      showToast("Please provide at least one service cost", "Error");
      return;
    }

    const generalServices = {
      serviceType: "General Services",
      fee: Number(amount || 0),
      services: personalCareItems,
    };

    const otherServicesArray = Object.entries(amountStates).map(
      ([service, cost]) => ({
        serviceType: service,
        fee: Number(cost || 0),
      })
    );

    const onetime = [generalServices, ...otherServicesArray];

    const data = {
      oneTimeServices: onetime,
      oneTimeVisits: { fromTime: new Date(fromTime), toTime: new Date(toTime) },
      otherServices: otherServices,
    };

    console.log("Submitting data:", data);

    try {
      const update = await UpdateOneTimeServices(data);

      if (update.error === false) {
        console.log(update.data);
        secureLocalStorage.setItem("ratefix", true);
        navigate("/bankdetails");
      } else {
        console.log(update.error);
      }
    } catch (error) {
      console.log("Error:", error);
      showToast(
        "Something went wrong while submitting. Please try again.",
        "Error"
      );
    }
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-[#4951EC]">
      <div className="mb-10">
        <StepProgress currentStep={2} />
      </div>

      <div className="p-6 w-full max-w-xl bg-white rounded-md shadow-md space-y-4 h-[70vh]">
        <h2 className="text-[16px] font-bold mx-auto text-center font-poppins">
          Set Duty & Fee
        </h2>

        <div className="flex justify-center mb-20">
          <button
            className={`px-12 py-1 rounded-l-lg font-poppins transition text-[12px] 
    ${
      activeTab === "regular"
        ? "bg-indigo-600 text-white cursor-pointer"
        : "bg-indigo-100 text-indigo-600 hover:bg-indigo-200 cursor-pointer"
    }`}
            onClick={() => setActiveTab("regular")}
          >
            Regular Visit
          </button>

          <button
            disabled={isNextAllowed}
            className={`px-10 py-1 rounded-r-lg font-poppins transition text-[12px] 
    ${
      isNextAllowed
        ? activeTab === "onetime"
          ? "bg-indigo-600 text-white cursor-pointer"
          : "bg-indigo-100 text-indigo-600 cursor-pointer hover:bg-indigo-100"
        : "bg-gray-300 text-gray-500 cursor-not-allowed"
    }`}
            onClick={() => {
              if (isNextAllowed) setActiveTab("onetime");
            }}
          >
            Onetime Visit
          </button>
        </div>

        {activeTab === "regular" ? (
          <div className="h-[288px] pt-2">
            {[
              { label: "24H", key: "24/7" },
              { label: "Morning 9H", key: "morning9" },
              { label: "Morning 12H", key: "morning12" },
              { label: "Night 12H", key: "night12" },
            ].map(({ label, key }) => (
              <div key={key} className="space-y-4 mb-6">
                <div className="flex items-center justify-between space-x-4 mx-6">
                  <div className="flex items-center space-x-2">
                    <input
                      type="checkbox"
                      checked={checkedRates[key]}
                      onChange={() => handleCheckboxChange(key)}
                      className="w-4 h-4"
                    />
                    <label className="text-sm font-medium font-poppins">
                      {label}
                    </label>
                  </div>
                  <input
                    type="number"
                    placeholder="Enter Amount"
                    disabled={!checkedRates[key]}
                    value={rates[key] ?? ""}
                    onChange={(e) => handleRateChange(key, e.target.value)}
                    className={`border text-[12px] font-poppins rounded px-3 py-1 w-40 ${
                      checkedRates[key]
                        ? "bg-white border border-blue-500"
                        : "bg-gray-100 cursor-not-allowed"
                    }`}
                  />
                </div>

                {checkedRates[key] && (
                  <div className="ml-6 mt-1">
                    {key === "24/7" ? (
                      // <div className="text-sm text-gray-600 font-poppins">
                      //   Start Time:{" "}
                      //   <span className="font-semibold">{startTime247}</span>
                      // </div>
                      <>
                        <p></p>
                      </>
                    ) : (
                      <div className="flex flex-wrap gap-2 mt-4">
                        {timeSlotOptions[key]?.map((slot) => (
                          <button
                            key={slot}
                            onClick={() => handleTimeSlotToggle(key, slot)}
                            className={`px-3 py-1 text-xs font-poppins rounded border ${
                              timeSlots[key].includes(slot)
                                ? "bg-blue-500 text-white"
                                : "bg-white text-gray-800"
                            }`}
                          >
                            {slot}
                          </button>
                        ))}
                      </div>
                    )}
                  </div>
                )}
              </div>
            ))}
          </div>
        ) : (
          <div className="p-4 max-w-md mx-auto h-[40vh] overflow-y-auto">
            <p className="font-poppins text-[13px] text-[blue] mb-2 font-medium">
              Time Slot
            </p>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <div className="flex gap-4 items-center pb-6">
                {/* From Time */}
                <div className="flex flex-col">
                  <label className="text-[13px] font-medium font-poppins text-gray-700 mb-1">
                    From
                  </label>
                  <ThemeProvider theme={theme}>
                    <DesktopTimePicker
                      value={fromTime}
                      onChange={setFromTime}
                      ampm
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          placeholder="From Time"
                          size="small"
                          sx={{ width: 120 }}
                        />
                      )}
                    />
                  </ThemeProvider>
                </div>

                {/* To Time */}
                <div className="flex flex-col">
                  <label className="text-[13px] font-medium font-poppins text-gray-700 mb-1">
                    To
                  </label>
                  <ThemeProvider theme={theme}>
                    <DesktopTimePicker
                      value={toTime}
                      onChange={setToTime}
                      ampm
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          size="small"
                          sx={{ width: 120 }}
                        />
                      )}
                    />
                  </ThemeProvider>
                </div>
              </div>
            </LocalizationProvider>
            {/* Personal Care */}
            <div className="bg-white border border-[#DDE9F0] rounded-md p-3 mb-4 shadow-sm">
              <div className="flex items-center justify-between gap-4 py-2">
                {/* Checkbox + Label */}
                <div className="flex items-center gap-2">
                  <input
                    type="checkbox"
                    id="generalServices"
                    checked={isChecked}
                    onChange={(e) => setIsChecked(e.target.checked)}
                    className="w-4 h-4 text-blue-600"
                  />
                  <label
                    htmlFor="generalServices"
                    className="text-[14px] font-poppins font-medium"
                  >
                    General Services
                  </label>
                </div>

                {/* Amount input */}
                <input
                  type="number"
                  placeholder="Amount"
                  value={amount}
                  disabled={!isChecked}
                  onChange={(e) => setAmount(e.target.value)}
                  className="w-28 px-2 py-1 text-[13px] border border-gray-300 rounded-md focus:outline-none focus:border-blue-500"
                />
              </div>

              {/* {showPersonalCare && ( */}
              <div className="mt-4">
                {personalCareItems.map((item, index) => (
                  <div
                    key={index}
                    className="flex justify-between items-center mb-2"
                  >
                    <div className="flex items-center space-x-2">
                      {/* <input
                          type="checkbox"
                          checked={personalChecked[item] || false}
                          onChange={() =>
                            setPersonalChecked((prev) => ({
                              ...prev,
                              [item]: !prev[item],
                            }))
                          }
                          className="w-3.5 h-3.5 text-blue-500"
                        /> */}
                      <label className="text-[12px] font-poppins  text-gray-700">
                        {item}
                      </label>
                    </div>
                    <input
                      type="text"
                      placeholder=""
                      value={personalAmount[item] || ""}
                      onChange={(e) =>
                        setPersonalAmount((prev) => ({
                          ...prev,
                          [item]: e.target.value,
                        }))
                      }
                      disabled={!personalChecked[item]}
                      className={`text-[12px] font-poppins border px-2 py-1 w-24 text-center rounded ${
                        personalChecked[item]
                          ? "border-blue-400 bg-white"
                          : "border-gray-200 bg-gray-100 cursor-not-allowed"
                      }`}
                    />
                  </div>
                ))}
              </div>
              {/* )} */}
            </div>
            {serviceCategories.map(({ title, key }) => (
              <div
                key={key}
                className="bg-white border border-[#DDE9F0] p-3 rounded-md  mb-4 shadow-sm"
              >
                <div className="flex justify-between items-center">
                  <div className="flex items-center space-x-2">
                    <input
                      type="checkbox"
                      checked={checkedStates[key] || false}
                      onChange={() =>
                        setCheckedStates((prev) => ({
                          ...prev,
                          [key]: !prev[key],
                        }))
                      }
                      className="w-3.5 h-3.5 text-blue-500"
                    />
                    <label className="text-[14px] font-poppins font-medium ">
                      {title}
                    </label>
                  </div>
                  <input
                    type="text"
                    placeholder="Enter"
                    value={amountStates[key] || ""}
                    onChange={(e) =>
                      setAmountStates((prev) => ({
                        ...prev,
                        [key]: e.target.value,
                      }))
                    }
                    disabled={!checkedStates[key]}
                    className={`text-[12px] font-poppins border px-2 py-1 w-24 text-center rounded ${
                      checkedStates[key]
                        ? "border-blue-400 bg-white"
                        : "border-gray-200 bg-gray-100 cursor-not-allowed"
                    }`}
                  />
                </div>
              </div>
            ))}
            <p className="text-[13px] font-medium text-[blue] font-poppins mb-2">
              Other Services
            </p>
            <textarea
              placeholder="Enter Services"
              value={otherServices}
              onChange={(e) => setOtherServices(e.target.value)}
              className="w-full  border border-white-300 rounded-md px-2 py-2  text-[12px] placeholder-gray focus:outline-none focus:border-blue-500 h-24 font-poppins"
            ></textarea>
          </div>
        )}

        <div className="flex justify-center pt-8">
          {activeTab === "regular" ? (
            <>
              <button
                onClick={handleNext}
                className="bg-custom-gradient text-white px-6 py-2 font-poppins rounded hover:bg-blue-600 text-sm"
              >
                Next
              </button>
            </>
          ) : (
            <>
              <button
                onClick={handleSubmit}
                className="bg-custom-gradient text-white px-6 py-2 font-poppins rounded hover:bg-blue-600 text-sm"
              >
                Submit
              </button>
            </>
          )}
        </div>
      </div>

      {/* {toastMsg && <Toaster action={toastMsg.action} msg={toastMsg.msg} />} */}
    </div>
  );
};

export default RateFix;
